import { useEffect, useState } from "react";
import { getExpirationDate } from "../utils/getExpirationDate";

export const useCookies = (cookieName: string): {cookieValue: string, setCookie: (value: string, expirationDate?: Date) => void, deleteCookie: () => void} => {
  const [cookieValue, setCookieValue] = useState<string>("");

  useEffect(() => {
    const cookieLine = document.cookie.split("; ").find((row) => row.startsWith(`${cookieName}=`));
    const cookieValue = cookieLine?.split('=')?.[1];

    setCookieValue(cookieValue || "");
  }, [cookieName]);

  const setCookie = (value: string, expirationDate = getExpirationDate(1)) => {
    document.cookie = `${cookieName}=${value}; expires=${expirationDate.toUTCString()}; path=/`
  };
  
  const deleteCookie = () => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  };

  return {cookieValue, setCookie, deleteCookie};
}